import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Form,
  Modal,
  Dropdown,
  Tabs,
  Tab,
} from "react-bootstrap";
import {
  Truck,
  CheckCircle,
  XCircle,
  Search,
  MoreVertical,
  Star,
  Eye,
  Ban,
  X,
  AlertCircle,
} from "lucide-react";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout ";
import "../../../assets/styles/admin/AdminDistributors.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const AdminDistributors = () => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showSuspendAlert, setShowSuspendAlert] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("customers");
  const [distributors, setDistributors] = useState([]);
  const [distributorStatus, setDistributorStatus] = useState('');
  const {baseUrl} = useContext(AppContext);

  // Stats data
  const statsData = [
    {
      id: 1,
      title: "Total",
      value: "156",
      icon: Truck,
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 2,
      title: "Active",
      value: "142",
      icon: CheckCircle,
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 3,
      title: "Suspended",
      value: "14",
      icon: XCircle,
      iconBg: "#fee2e2",
      iconColor: "#dc2626",
    },
    {
      id: 4,
      title: "Avg Rating",
      value: "4.6",
      icon: Star,
      iconBg: "#fef3c7",
      iconColor: "#f59e0b",
    },
  ];

  // Distributors data
  // const distributors = [
  //   {
  //     id: 1,
  //     name: "Ahmad Dairy",
  //     email: "ahmad@dairy.com",
  //     cityArea: "Lahore, Gulberg",
  //     supplier: "Milk Fresh Co.",
  //     customers: 45,
  //     rating: 4.8,
  //     plan: "Premium",
  //     status: "active",
  //     phone: "0300-1111111",
  //     location: "Lahore, Gulberg",
  //     customersList: [
  //       {
  //         name: "Fatima Bibi",
  //         email: "fatima@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //       {
  //         name: "Ali Raza",
  //         email: "ali.raza@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //       {
  //         name: "Zainab Fatima",
  //         email: "zainab@gmail.com",
  //         cityArea: "Lahore, DHA",
  //         plan: "Basic",
  //         status: "suspended",
  //       },
  //     ],
  //     supplierInfo: { name: "Milk Fresh Co.", email: "info@milkfresh.com" },
  //   },
  //   {
  //     id: 2,
  //     name: "Hassan Milk Supply",
  //     email: "hassan@milk.com",
  //     cityArea: "Lahore, DHA",
  //     supplier: "Milk Fresh Co.",
  //     customers: 32,
  //     rating: 4.5,
  //     plan: "Standard",
  //     status: "active",
  //     phone: "0300-2222222",
  //     location: "Lahore, DHA",
  //     customersList: [
  //       {
  //         name: "Fatima Bibi",
  //         email: "fatima@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //       {
  //         name: "Ali Raza",
  //         email: "ali.raza@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //     ],
  //     supplierInfo: { name: "Milk Fresh Co.", email: "info@milkfresh.com" },
  //   },
  //   {
  //     id: 3,
  //     name: "Bilal Fresh Milk",
  //     email: "bilal@fresh.com",
  //     cityArea: "Islamabad, F-8",
  //     supplier: "Green Valley Milk",
  //     customers: 28,
  //     rating: 4.7,
  //     plan: "Basic",
  //     status: "active",
  //     phone: "0300-3333333",
  //     location: "Islamabad, F-8",
  //     customersList: [
  //       {
  //         name: "Fatima Bibi",
  //         email: "fatima@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //     ],
  //     supplierInfo: {
  //       name: "Green Valley Milk",
  //       email: "hello@greenvalley.com",
  //     },
  //   },
  //   {
  //     id: 4,
  //     name: "Karachi Dairy Hub",
  //     email: "karachi@dairy.com",
  //     cityArea: "Karachi, Clifton",
  //     supplier: "Punjab Dairy Farm",
  //     customers: 60,
  //     rating: 4.2,
  //     plan: "Premium",
  //     status: "suspended",
  //     phone: "0300-4444444",
  //     location: "Karachi, Clifton",
  //     customersList: [
  //       {
  //         name: "Fatima Bibi",
  //         email: "fatima@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //       {
  //         name: "Ali Raza",
  //         email: "ali.raza@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //     ],
  //     supplierInfo: {
  //       name: "Punjab Dairy Farm",
  //       email: "contact@punjabdairy.com",
  //     },
  //   },
  //   {
  //     id: 5,
  //     name: "Multan Pure Milk",
  //     email: "multan@pure.com",
  //     cityArea: "Multan, Cantt",
  //     supplier: "Sahiwal Pure Milk",
  //     customers: 18,
  //     rating: 4.9,
  //     plan: "Free",
  //     status: "active",
  //     phone: "0300-5555555",
  //     location: "Multan, Cantt",
  //     customersList: [
  //       {
  //         name: "Fatima Bibi",
  //         email: "fatima@gmail.com",
  //         cityArea: "Lahore, Gulberg",
  //         plan: "Basic",
  //         status: "active",
  //       },
  //     ],
  //     supplierInfo: {
  //       name: "Sahiwal Pure Milk",
  //       email: "info@sahiwalpure.com",
  //     },
  //   },
  // ];

  const handleViewDetails = (distributor) => {
    setSelectedDistributor(distributor);
    setShowDetailsModal(true);
    setActiveTab("customers");
  };

  const changeDistributorStatus = (distributor) => {
    console.log("Update status function called");
    console.log(distributor);
    const formData = new FormData();
    formData.append("id", distributor.id);
      axios.post(`${baseUrl}/admin/distributor/changeDistributorStatus`, formData, {
        "content-header" : "multipart-formdata"
      }
    ).then((response) => {
      // console.log(response.data);
      if(response.data.success == true){
        console.log(response.data);
        Swal.fire({
          title: "Updated",
          text: (response.data.message),
          icon:'success',
          confirmButtonText : 'Cool'
        })
        viewAllDistributors();
      }

    }).catch((error)=>{
      console.log(error)
    })
  };

  const handleCloseModal = () => {
    setShowDetailsModal(false);
    setSelectedDistributor(null);
  };

  const handleCloseSuspendAlert = () => {
    setShowSuspendAlert(false);
    setSelectedDistributor(null);
  };

  // const getPlanBadgeClass = (plan) => {
  //   switch (plan.toLowerCase()) {
  //     case "premium":
  //       return "admin-distributors-badge-premium";
  //     case "standard":
  //       return "admin-distributors-badge-standard";
  //     case "basic":
  //       return "admin-distributors-badge-basic";
  //     case "free":
  //       return "admin-distributors-badge-free";
  //     default:
  //       return "admin-distributors-badge-default";
  //   }
  // };

  const viewAllDistributors = () => {
    console.log("view all distributor function called");
    axios.get(`${baseUrl}/admin/distributor/viewAllDistributors`)
    .then((response)=>{
      if(response.data.success === true){
        console.log("all distributors", response.data.distributors);
        setDistributors(response.data.distributors);
      }
    }).catch((error)=>{
      console.log(error);
    })

  };

  useEffect(() => {
    viewAllDistributors();
  }, []);

  return (
    <AdminMasterLayout>
      <div className="admin-distributors-wrapper">
        {/* Page Header */}
        <div className="admin-distributors-header">
          <div>
            <h1 className="admin-distributors-title">Distributors</h1>
            <p className="admin-distributors-subtitle">
              Manage all registered distributors
            </p>
          </div>
          <div className="admin-distributors-search-wrapper">
            <Search className="admin-distributors-search-icon" size={20} />
            <Form.Control
              type="text"
              placeholder="Search distributors..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="admin-distributors-search-input"
            />
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="admin-distributors-stats-row g-3 g-lg-4">
          {statsData.map((stat, index) => (
            <Col xs={12} sm={6} lg={3} key={stat.id}>
              <Card
                className="admin-distributors-stat-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <Card.Body>
                  <div className="admin-distributors-stat-content">
                    <div
                      className="admin-distributors-stat-icon-box"
                      style={{ backgroundColor: stat.iconBg }}
                    >
                      <stat.icon
                        size={24}
                        style={{ color: stat.iconColor }}
                        strokeWidth={2}
                      />
                    </div>
                    <div className="admin-distributors-stat-info">
                      <span className="admin-distributors-stat-label">
                        {stat.title}
                      </span>
                      <h3 className="admin-distributors-stat-value">
                        {stat.value}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Table Section */}
        <Card className="admin-distributors-table-card">
          <Card.Body>
            <div className="admin-distributors-table-wrapper">
              <Table responsive className="admin-distributors-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>City / Area</th>
                    <th>Supplier</th>
                    <th>Customers</th>
                    <th>Rating</th>
                    <th>Plan</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {distributors.map((distributor, index) => (
                    <tr
                      key={distributor.id}
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <td>
                        <div className="admin-distributors-name-cell">
                          <span className="admin-distributors-name">
                            {distributor.fullName}
                          </span>
                          <span className="admin-distributors-email">
                            {distributor.email}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span className="admin-distributors-city">
                          {distributor.city_id}
                        </span>
                      </td>
                      <td>
                        <span className="admin-distributors-supplier">
                          {distributor.supplier}
                        </span>
                      </td>
                      <td>
                        <span className="admin-distributors-count">
                          {distributor.customers}
                        </span>
                      </td>
                      <td>
                        <div className="admin-distributors-rating">
                          <Star size={16} fill="#fbbf24" color="#fbbf24" />
                          <span>{distributor.rating}</span>
                        </div>
                      </td>
                      <td>
                        <Badge
                          // className={`admin-distributors-plan-badge ${getPlanBadgeClass(distributor.plan)}`}
                          className='admin-distributors-plan-badge'
                        >
                          {distributor.plan}
                        </Badge>
                      </td>
                      <td>
                        <Badge
                          bg={
                            distributor.status === "active"
                              ? "primary"
                              : "danger"
                          }
                          className="admin-distributors-status-badge"
                        >
                          {distributor.status}
                        </Badge>
                      </td>
                      <td>
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            variant="link"
                            className="admin-distributors-actions-btn"
                            bsPrefix="admin-distributors-dropdown-toggle"
                          >
                            <MoreVertical size={18} />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="admin-distributors-dropdown-menu">
                            <Dropdown.Item
                              onClick={() => handleViewDetails(distributor)}
                              className="admin-distributors-dropdown-item"
                            >
                              <Eye size={16} className="me-2" />
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => changeDistributorStatus(distributor)}
                              className="admin-distributors-dropdown-item admin-distributors-dropdown-item-danger"
                            >
                              <Ban size={16} className="me-2" />
                              {distributor.status === "active"
                                ? "Deactive"
                                : "Activate"}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>

        {/* View Details Modal */}
        <Modal
          show={showDetailsModal}
          onHide={handleCloseModal}
          size="lg"
          centered
          className="admin-distributors-modal"
        >
          <Modal.Header className="admin-distributors-modal-header">
            <Modal.Title className="admin-distributors-modal-title">
              {selectedDistributor?.name} — Details
            </Modal.Title>
            <button
              className="admin-distributors-modal-close"
              onClick={handleCloseModal}
            >
              <X size={20} />
            </button>
          </Modal.Header>
          <Modal.Body className="admin-distributors-modal-body">
            {selectedDistributor && (
              <>
                {/* Distributor Info */}
                <div className="admin-distributors-modal-info">
                  <div className="admin-distributors-modal-info-item">
                    <span className="admin-distributors-modal-info-label">
                      Email:
                    </span>
                    <span className="admin-distributors-modal-info-value">
                      {selectedDistributor.email}
                    </span>
                  </div>
                  <div className="admin-distributors-modal-info-item">
                    <span className="admin-distributors-modal-info-label">
                      Phone:
                    </span>
                    <span className="admin-distributors-modal-info-value">
                      {selectedDistributor.phone}
                    </span>
                  </div>
                  <div className="admin-distributors-modal-info-item">
                    <span className="admin-distributors-modal-info-label">
                      Location:
                    </span>
                    <span className="admin-distributors-modal-info-value">
                      {selectedDistributor.location}
                    </span>
                  </div>
                  <div className="admin-distributors-modal-info-item">
                    <span className="admin-distributors-modal-info-label">
                      Plan:
                    </span>
                    <span className="admin-distributors-modal-info-value">
                      {selectedDistributor.plan}
                    </span>
                  </div>
                </div>

                {/* Tabs */}
                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className="admin-distributors-tabs"
                >
                  <Tab
                    eventKey="customers"
                    // title={`Customers (${selectedDistributor.customersList.length})`}
                    title='Customers'
                    className="admin-distributors-tab"
                  >
                    <div className="admin-distributors-tab-content">
                      <Table
                        responsive
                        className="admin-distributors-modal-table"
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>City / Area</th>
                            <th>Plan</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedDistributor.customersList.map(
                            (customer, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="admin-distributors-modal-name-cell">
                                    <span className="admin-distributors-modal-name">
                                      {customer.name}
                                    </span>
                                    <span className="admin-distributors-modal-email">
                                      {customer.email}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <span className="admin-distributors-modal-city">
                                    {customer.cityArea}
                                  </span>
                                </td>
                                <td>
                                  <Badge
                                    // className={`admin-distributors-plan-badge ${getPlanBadgeClass(customer.plan)}`}
                                    className="admin-distributors-plan-badge"
                                  >
                                    {customer.plan}
                                  </Badge>
                                </td>
                                <td>
                                  <Badge
                                    bg={
                                      customer.status === "active"
                                        ? "primary"
                                        : "danger"
                                    }
                                    className="admin-distributors-status-badge"
                                  >
                                    {customer.status}
                                  </Badge>
                                </td>
                              </tr>
                            ),
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="supplier"
                    title="Supplier (1)"
                    className="admin-distributors-tab"
                  >
                    <div className="admin-distributors-tab-content">
                      <div className="admin-distributors-supplier-info">
                        <div className="admin-distributors-supplier-item">
                          <span className="admin-distributors-supplier-label">
                            Name:
                          </span>
                          <span className="admin-distributors-supplier-value">
                            {selectedDistributor.supplierInfo.name}
                          </span>
                        </div>
                        <div className="admin-distributors-supplier-item">
                          <span className="admin-distributors-supplier-label">
                            Email:
                          </span>
                          <span className="admin-distributors-supplier-value">
                            {selectedDistributor.supplierInfo.email}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* Suspend Alert Modal */}
        <Modal
          show={showSuspendAlert}
          onHide={handleCloseSuspendAlert}
          centered
          className="admin-distributors-alert-modal"
        >
          <Modal.Body className="admin-distributors-alert-body">
            <div className="admin-distributors-alert-icon">
              <AlertCircle size={48} color="#dc2626" />
            </div>
            <h4 className="admin-distributors-alert-title">
              {selectedDistributor?.status === "active"
                ? "Suspend Distributor?"
                : "Activate Distributor?"}
            </h4>
            <p className="admin-distributors-alert-text">
              {selectedDistributor?.status === "active"
                ? `Are you sure you want to suspend ${selectedDistributor?.name}? They will lose access to the platform.`
                : `Are you sure you want to activate ${selectedDistributor?.name}? They will regain access to the platform.`}
            </p>
            <div className="admin-distributors-alert-actions">
              <button
                className="admin-distributors-alert-btn admin-distributors-alert-btn-cancel"
                onClick={handleCloseSuspendAlert}
              >
                Cancel
              </button>
              <button
                className="admin-distributors-alert-btn admin-distributors-alert-btn-confirm"
                onClick={handleCloseSuspendAlert}
              >
                {selectedDistributor?.status === "active"
                  ? "Suspend"
                  : "Activate"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </AdminMasterLayout>
  );
};

export default AdminDistributors;
